<template>
  <section class="discount-bookmark" @click="togglePopup(true)">
    <span class="discount-bookmark__text">
      {{ $t("gift_for_you") }}
    </span>
  </section>

  <section class="discount-popup" :class="{ hidden: !show }">
    <div class="discount-popup__backdrop">
      <div class="discount-popup__content">
        <a class="discount-popup__close" @click="togglePopup(false)">
          <img
            :src="url('/img/icons/cancel-white.svg')"
            alt="Zatvoriť okno"
            class="discount-popup__close-image"
          />
        </a>
        <div class="discount-popup__challenge" :class="{ hidden: sent }">
          <h2 class="discount-popup__title">
            {{ $t("discount_challenge_title", { value: discountValue }) }}
          </h2>
          <p
            class="discount-popup__text"
            v-html="$t('discount_challenge_text', { value: discountValue })"
          ></p>
          <Form @submit="onSubmit">
            <Input
              :placeholder="$t('Email')"
              id="email"
              name="email"
              rules="required|email"
              classes=""
              input-class="discount-popup__input"
              :value="email"
              @updated-value="SET_EMAIL($event.value)"
            />
            <button class="discount-popup__primary-btn primary-btn">
              {{
                $t("discount_challenge_primary_btn", { value: discountValue })
              }}
            </button>
            <button
              type="button"
              class="discount-popup__secondary-btn"
              @click="togglePopup(false)"
            >
              {{ $t("discount_challenge_secondary_btn") }}
            </button>
          </Form>
          <small
            class="discount-popup__text--small"
            v-html="$t('discount_challenge_link', { link: vop() })"
          ></small>
        </div>
        <div class="discount-popup__thanks" :class="{ hidden: !sent }">
          <h2 class="discount-popup__title">
            {{ $t("discount_thanks_title") }}
          </h2>
          <p
            class="discount-popup__text"
            v-html="$t('discount_thanks_text1')"
          ></p>
          <p
            class="discount-popup__text"
            v-html="$t('discount_thanks_text2')"
          ></p>
          <button
            type="button"
            class="discount-popup__primary-btn primary-btn"
            @click="togglePopup(false)"
          >
            {{ $t("Close") }}
          </button>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import { Form } from "vee-validate";
import { useToast } from "vue-toastification";
import Input from "./input/Input";
import useRoutes from "./../../useRoutes";
import useGlobal from "../../useGlobal";
import useDiscountPopup from "./useDiscountPopup";

export default {
  components: {
    Form,
    Input,
  },
  props: {
    discountValue: {
      type: Number,
    },
  },
  computed: {
    ...mapGetters({
      sent: "discountPopup/getSent",
      show: "discountPopup/getShow",
      email: "discountPopup/getEmail",
    }),
  },
  methods: {
    ...mapMutations("discountPopup", ["SET_EMAIL"]),
  },
  setup() {
    const toast = useToast();
    const { vop } = useRoutes();
    const { url } = useGlobal();
    const { onSubmit, togglePopup, loadData } = useDiscountPopup();

    loadData();

    return {
      toast,
      vop,
      url,
      onSubmit,
      togglePopup,
    };
  },
};
</script>
